










import { State, Getter, Action, Mutation } from 'vuex-class'
import { Component, Vue, Prop } from 'vue-property-decorator'
import 'codemirror/addon/runmode/runmode.js'
import 'codemirror/theme/mdn-like.css'
import { normalizeModeName } from 'vue-codemirror-component'

import SvgIcon from './SvgIcon'
import CodeMirror from 'codemirror'
import Clipboard from 'clipboard';

@Component({ components: { SvgIcon } })
export default class VueCodemirrorPreview extends Vue {
  @Prop()
  bg: string

  @Prop()
  code: string

  @Prop({ default: 'javascript' })
  lang: string

  copied: boolean = false

  updated() {
    const mode = normalizeModeName(this.lang)
    CodeMirror.runMode(this.code, mode, (this.$refs.code as any))
  }

  clip() {
    const code = this.code.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&')
    const clipboard = new Clipboard('.copy', {
      text () {
        return code
      }
    })

    clipboard.on('success', (e) => {
      e.clearSelection()
      clipboard.destroy()
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    });
  }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/vue-codemirror-preview.vue